import { isNull } from 'utils/isEmpty';

function trimValue(value: string) {
  return value && value.length > 144 ? `${value.substring(0, 144)}...` : value;
}

export const getLabel = (e: HTMLElement) => {
  let text = e.textContent || e.innerText;
  if (!isNull(text)) {
    text = text.trim();
  }
  let ariaLabel = e.getAttribute('data-tip');
  if (!isNull(ariaLabel)) {
    ariaLabel = ariaLabel.trim();
  }
  if (isNull(ariaLabel)) {
    ariaLabel = e.getAttribute('aria-label');
    if (!isNull(ariaLabel)) {
      ariaLabel = ariaLabel.trim();
    }
  }
  const type = e.getAttribute('type');
  switch (e.tagName?.toLowerCase()) {
    case 'textarea':
    case 'input':
      let fieldType = 'field';
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      type &&
        ((fieldType = type.toLowerCase()),
        fieldType === 'tel'
          ? (fieldType = 'telephone field')
          : fieldType === 'datetime-local'
          ? (fieldType = 'date and time field')
          : fieldType === 'checkbox'
          ? (fieldType = 'checkbox')
          : fieldType === 'radio'
          ? (fieldType = 'radio button')
          : fieldType === 'submit'
          ? (fieldType = 'button')
          : (fieldType = `${fieldType} field`));
      if (e.classList.contains('lov')) {
        fieldType = 'lov field';
      }
      if (e.classList.contains('date')) {
        fieldType = 'date field';
      }
      let operation = 'Click';
      if (type === 'checkbox') {
        operation = (e as HTMLInputElement).checked ? 'Check' : 'Uncheck';
      }
      const { labels: fieldLabels } = e as HTMLInputElement;
      let o;
      if (fieldLabels) {
        if (fieldLabels && fieldLabels.length > 0) {
          if (fieldLabels[0].innerText && fieldLabels[0].innerText !== '') {
            o = fieldLabels[0].innerText.trim();
          }
          if (
            !o &&
            fieldLabels[0].textContent &&
            fieldLabels[0].textContent !== ''
          ) {
            o = fieldLabels[0].textContent.trim();
          }
        }
        if (!o && e.getAttribute('placeholder')) {
          o = e.getAttribute('placeholder')?.trim();
        }
        if (o && o.endsWith('*')) {
          o = o.slice(0, -1).trim();
        }
        return !o
          ? `${operation} this ${fieldType}.`
          : `${operation} the "${o}" ${fieldType}.`;
      }

      return ariaLabel ? `${operation} "${ariaLabel}".` : `${operation} here.`;
    case 'select':
      return 'Click this dropdown.';
    case 'a':
      return text ? `Click "${text}"` : 'Click this link.';
    case 'button': {
      let sufix = '';
      let t = text || ariaLabel;
      if (t && text.includes('.') && ariaLabel) {
        t = ariaLabel;
      }
      if (t && e.classList.contains('tabitem')) {
        sufix = ' tab';
      }
      return t ? `Click "${t}"${sufix}` : 'Click this button.';
    }
    case 'svg':
      if (ariaLabel) return `Click "${trimValue(ariaLabel)}"`;
      return 'Click this icon.';
    case 'img':
      if (ariaLabel) return `Click "${trimValue(ariaLabel)}"`;
      return 'Click this image.';
    case 'li':
    case 'div': {
      text = '';
      if (e.childNodes.length) {
        e.childNodes.forEach((n) => {
          if (n.nodeType === 3 && !text) {
            text = n.textContent ?? '';
            if (!isNull(text)) {
              text = text.trim();
            }
          }
        });
      }
      const cl = e.classList;
      const label = text || ariaLabel;
      let sufix = '';
      if (label) {
        if (cl.contains('io-pivotgrid-group-cell-header')) {
          sufix = ' column group header';
        } else if (cl.contains('io-pivotgrid-cell-header')) {
          sufix = ' column header';
        }
      }
      if (label) {
        return `Click "${trimValue(label)}"${sufix}`;
      }
      if (cl.contains('dvn-scroller')) {
        return 'Click here on the grid.';
      }
      return 'Click here.';
    }
    case 'style':
      return 'Click here.';
    default:
      const a = text || ariaLabel;
      return a ? `Click "${trimValue(a)}"` : 'Click here.';
  }
};
